import Vue from 'vue'
import VueRouter from 'vue-router'
import CheckStore from './middleware/check-store'
import CheckType from './middleware/check-type'
import CheckUrlId from './middleware/check-url-id'
import { store } from '@/store/index'

Vue.use(VueRouter)

const Reservation = () => import('./views/reservation/Index').then(m => m.default || m)
const ReservationMenu = () => import('./views/reservation/MenuGroupProduct').then(m => m.default || m)
const ReserveTime = () => import('./views/reservation/ReserveTime').then(m => m.default || m)
const TakeAway = () => import('./views/takeaway/Index').then(m => m.default || m)
const TakeAwayMenu = () => import('./views/takeaway/MenuGroupProduct').then(m => m.default || m)
const TimeToTake = () => import('./views/takeaway/TimeToTake').then(m => m.default || m)
const Delivery = () => import('./views/delivery/Index').then(m => m.default || m)
const DeliveryMenu = () => import('./views/delivery/MenuGroupProduct').then(m => m.default || m)
const DeliveryMethod = () => import('./views/delivery/DeliveryMethod').then(m => m.default || m)
const DeliveryTime = () => import('./views/delivery/DeliveryTime').then(m => m.default || m)
const DineIn = () => import('./views/dinein/Index').then(m => m.default || m)
const DineInMenu = () => import('./views/dinein/MenuGroupProduct').then(m => m.default || m)
const SelectTable = () => import('./views/dinein/SelectTable').then(m => m.default || m)
const ScanQr = () => import('./views/dinein/ScanQr').then(m => m.default || m)
const ScanQRCamera = () => import('./views/dinein/ScanQRCamera').then(m => m.default || m)
const TotalGuest = () => import('./views/dinein/TotalGuest').then(m => m.default || m)
const Login = () => import('./views/auth/Login').then(m => m.default || m)
const LoginGuest = () => import('./views/auth/LoginGuest').then(m => m.default || m)
const Register = () => import('./views/auth/Register').then(m => m.default || m)
const SelectVerification = () => import('./views/auth/SelectVerification').then(m => m.default || m)
const SelectOTPLogin = () => import('./views/auth/SelectOTPLogin').then(m => m.default || m)
const RegisterSuccess = () => import('./views/auth/RegisterSuccess').then(m => m.default || m)
const CallVerification = () => import('./views/auth/CallVerification').then(m => m.default || m)
const CallVerificationLogin = () => import('./views/auth/CallVerificationLogin').then(m => m.default || m)
const VerificationOTP = () => import('./views/auth/VerificationOTP').then(m => m.default || m)
const VerificationOTPLogin = () => import('./views/auth/VerificationOTPLogin').then(m => m.default || m)
const ForgetPassword = () => import('./views/auth/ForgetPassword').then(m => m.default || m)
const ForgetVerificationOTP = () => import('./views/auth/ForgetVerificationOTP').then(m => m.default || m)
const ForgetVerificationOTPsms = () => import('./views/auth/ForgetVerificationOTPsms').then(m => m.default || m)
const NewPassword = () => import('./views/auth/NewPassword').then(m => m.default || m)
const SetNewPassword = () => import('./views/auth/SetNewPassword').then(m => m.default || m)
const Layout = () => import('./views/layouts/Layout').then(m => m.default || m)
const Blank = () => import('./views/layouts/Blank').then(m => m.default || m)
const Home = () => import('./views/Home').then(m => m.default || m)
const ListOutlets = () => import('./views/Outlets').then(m => m.default || m)
const Checkout = () => import('./views/checkout/Checkout').then(m => m.default || m)
const SearchMap = () => import('./views/maps/SearchMap').then(m => m.default || m)
const Payment = () => import('./views/payment/Payment').then(m => m.default || m)
const OrderFailed = () => import('./views/OrderFailed').then(m => m.default || m)
const OrderCancelled = () => import('./views/OrderCancelled').then(m => m.default || m)
const OrderPaymentPending = () => import('./views/OrderPaymentPending').then(m => m.default || m)
const OrderPaymentFailed = () => import('./views/OrderPaymentFailed').then(m => m.default || m)
const OrderSuccess = () => import('./views/OrderSuccess').then(m => m.default || m)
const VAOrder = () => import('./views/VAOrder').then(m => m.default || m)
const Qris = () => import('./views/Qris').then(m => m.default || m)
const CheckStatus = () => import('./views/CheckStatus').then(m => m.default || m)
const Orders = () => import('./views/order/Orders').then(m => m.default || m)
const Order = () => import('./views/order/Order').then(m => m.default || m)
const Transactions = () => import('./views/transaction/Transactions').then(m => m.default || m)
const Transaction = () => import('./views/transaction/Transaction').then(m => m.default || m)
const Favorite = () => import('./views/favorite/Index').then(m => m.default || m)
const LoyaltyPoint = () => import('./views/LoyaltyPoint').then(m => m.default || m)
const Vouchers = () => import('./views/voucher/Vouchers').then(m => m.default || m)
const ChangePassword = () => import('./views/account/ChangePassword').then(m => m.default || m)
const ChangePhone = () => import('./views/account/ChangePhone').then(m => m.default || m)
const ChangeEmail = () => import('./views/account/ChangeEmail').then(m => m.default || m)
const ChangePhoneVerification = () => import('./views/account/ChangePhoneVerification').then(m => m.default || m)
const QRCodeDineIn = () => import('./views/qrcode/DineIn').then(m => m.default || m)
const QRCodeTakeAway = () => import('./views/qrcode/TakeAway').then(m => m.default || m)
const QRCodeAstrapay = () => import('./views/qrcode/Astrapay').then(m => m.default || m)
const LearnMore = () => import('./views/LearnMore').then(m => m.default || m)
const StoreIsClose = () => import('./views/StoreIsClose').then(m => m.default || m)
const NonActive = () => import('./views/NonActive').then(m => m.default || m)
const RedirectSelectedType = () => import('./views/RedirectSelectedType').then(m => m.default || m)
const TermsConditions = () => import('./views/TermsConditions').then(m => m.default || m)
const PrivacyPolicy = () => import('./views/PrivacyPolicy').then(m => m.default || m)
const IndexMenuBook = () => import('./views/menubook/Index.vue').then(m => m.default || m)
const ListMenu = () => import('./views/menubook/ListMenu.vue').then(m => m.default || m)
const DetailMenu = () => import('./views/menubook/DetailMenu.vue').then(m => m.default || m)
const ReservationPlace = () => import('./views/place-reservation/Index').then(m => m.default || m)

const routes = [
  {
    path: '/menu-book',
    name: 'menu_book',
    component: IndexMenuBook,
    redirect: { name: 'list_menu' },
    children: [
      { path: 'list', name: 'list_menu', component: ListMenu },
      { path: 'list/:product_type/:id', name: 'detail_menu', component: DetailMenu }
    ]
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: { name: 'home' },
    children: [
      {
        path: '/reservation',
        name: 'reservation',
        component: Blank,
        redirect: { name: 'reserve_time' },
        children: [
          { path: 'reserve-time', name: 'reserve_time', component: ReserveTime },
          { path: 'menu', name: 'reservation_menu', component: Reservation },
          { path: 'menu/group/:id', name: 'reservation_menu_group', component: ReservationMenu }
        ]
      },
      {
        path: '/take-away',
        name: 'take_away',
        component: Blank,
        redirect: { name: 'take_time' },
        children: [
          { path: '/take-away/time-to-take', name: 'take_time', component: TimeToTake },
          { path: '/take-away/menu', name: 'take_away_menu', component: TakeAway },
          { path: '/take-away/menu/group/:id', name: 'take_away_menu_group', component: TakeAwayMenu }
        ]
      },
      {
        path: '/delivery',
        name: 'delivery',
        component: Blank,
        redirect: { name: 'delivery_menu' },
        children: [
          { path: '/delivery/menu', name: 'delivery_menu', component: Delivery },
          { path: '/delivery/menu/group/:id', name: 'delivery_menu_group', component: DeliveryMenu },
          { path: '/delivery/select-method', name: 'delivery_method', component: DeliveryMethod },
          { path: '/delivery/time', name: 'delivery_time', component: DeliveryTime }
        ]
      },
      {
        path: '/dinein',
        name: 'dinein',
        component: Blank,
        redirect: { name: 'scan_qr_code' },
        children: [
          { path: 'scan-qrcode', name: 'scan_qr_code', component: ScanQr },
          { path: 'total-guest', name: 'total_guest_dinein', component: TotalGuest },
          { path: 'select-table', name: 'select_table', component: SelectTable },
          { path: 'menu', name: 'dinein_menu', component: DineIn },
          { path: 'qrcode-camera', name: 'qr_code_camera', component: ScanQRCamera },
          { path: 'menu/group/:id', name: 'dinein_menu_group', component: DineInMenu }
        ]
      },
      { path: '/login', name: 'login', component: Login },
      { path: '/login-as-guest', name: 'login_guest', component: LoginGuest },
      { path: '/register', name: 'register', component: Register },
      { path: '/register/success', name: 'register_success', component: RegisterSuccess },
      { path: '/select-verification', name: 'select_verification', component: SelectVerification },
      { path: '/select-otp-login', name: 'select_otp_login', component: SelectOTPLogin },
      { path: '/call-verification', name: 'call_verification', component: CallVerification },
      { path: '/call-verification-login', name: 'call_verification_login', component: CallVerificationLogin },
      { path: '/verification', name: 'verification_otp', component: VerificationOTP },
      { path: '/verification-login', name: 'verification_otp_login', component: VerificationOTPLogin },
      { path: '/forget-password', name: 'forget_password', component: ForgetPassword },
      { path: '/forget-password/verification', name: 'forget_verification_otp', component: ForgetVerificationOTP },
      { path: '/forget-password/verification-sms', name: 'forget_verification_otp_sms', component: ForgetVerificationOTPsms },
      { path: '/forget-password/new-password', name: 'new_password', component: NewPassword },
      { path: '/set-new-password', name: 'set_new_password', component: SetNewPassword },
      { path: '/home', name: 'home', component: Home },
      { path: '/list-outlets', name: 'listoutlets', component: ListOutlets },
      { path: '/checkout', name: 'checkout', component: Checkout },
      { path: '/checkout/payment', name: 'payment', component: Payment },
      { path: '/checkout/payment/check', name: 'check_status', component: CheckStatus },
      { path: '/checkout/payment/failed', name: 'order_failed', component: OrderFailed },
      { path: '/checkout/payment/cancelled', name: 'order_cancelled', component: OrderCancelled },
      { path: '/checkout/payment/payment-pending', name: 'order_payment_pending', component: OrderPaymentPending },
      { path: '/checkout/payment/payment-failed', name: 'order_payment_failed', component: OrderPaymentFailed },
      { path: '/checkout/payment/success', name: 'order_success', component: OrderSuccess },
      { path: '/checkout/payment/virtual-account', name: 'va_order', component: VAOrder },
      { path: '/checkout/payment/qris', name: 'qris', component: Qris },
      {
        path: '/account',
        name: 'account_layout',
        component: Blank,
        children: [
          { path: 'change-password', name: 'change_password', component: ChangePassword },
          { path: 'change-phone', name: 'change_phone', component: ChangePhone },
          { path: 'change-email', name: 'change_email', component: ChangeEmail },
          { path: 'phone-verification', name: 'chenge_phone_verification', component: ChangePhoneVerification },
          { path: 'order', name: 'orders', component: Orders },
          { path: 'order/:id', name: 'order', component: Order },
          { path: 'transaction', name: 'transactions', component: Transactions },
          { path: 'transaction/:id', name: 'transaction', component: Transaction },
          { path: 'favorite', name: 'favorite', component: Favorite },
          { path: 'loyalty-point', name: 'loyalty_point', component: LoyaltyPoint },
          { path: 'voucher', name: 'vouchers', component: Vouchers }
        ]
      },
      { path: '/qrcode-dinein/:url_id/:store_id/:no_table', name: 'qrcode_dinein', component: QRCodeDineIn },
      { path: '/qrcode-takeaway/:url_id/:store_id', name: 'qrcode_takeaway', component: QRCodeTakeAway },
      { path: '/qrcode-astrapay', name: 'qrcode_astrapay', component: QRCodeAstrapay },
      { path: '/learn-more', name: 'learn_more', component: LearnMore },
      { path: '/maps/search', name: 'search_map', component: SearchMap },
      { path: '/close', name: 'store_is_close', component: StoreIsClose },
      { path: '/non-active', name: 'non_active', component: NonActive },
      { path: '/redirect/:selected_type', name: 'redirect_selected_type', component: RedirectSelectedType },
      { path: '/terms-conditions', name: 'terms_conditions', component: TermsConditions },
      { path: '/privacy-policy', name: 'privacy_policy', component: PrivacyPolicy },
      {
        path: '/reservation-place',
        name: 'reservation_place',
        component: ReservationPlace
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const whiteList = [
  'home',
  'listoutlets',
  'reservation',
  'reserve_time',
  'reservation_menu',
  'reservation_menu_group',
  'take_away',
  'take_time',
  'take_away_menu',
  'take_away_menu_group',
  'delivery',
  'delivery_menu',
  'delivery_menu_group',
  'delivery_method',
  'delivery_time',
  'dinein',
  'dinein_menu',
  'dinein_menu_group',
  'select_table',
  'scan_qr_code',
  'qr_code_camera',
  'total_guest_dinein',
  'checkout',
  'payment',
  'check_status',
  'order_failed',
  'order_cancelled',
  'order_payment_pending',
  'order_payment_failed',
  'order_success',
  'va_order',
  'qris'
]

const publicList = [
  'redirect_selected_type',
  'qrcode_dinein',
  'qrcode_takeaway',
  'qrcode_astrapay',
  'learn_more',
  'search_map',
  'store_is_close',
  'non_active',
  'terms_conditions',
  'privacy_policy'
]

const authlink = [
  'login',
  'login_guest',
  'register',
  'select_verification',
  'select_otp_login',
  'call_verification',
  'call_verification_login',
  'verification_otp',
  'verification_otp_login',
  'forget_password',
  'forget_verification_otp',
  'forget_verification_otp_sms',
  'new_password',
  'set_new_password'
]

const menubook = [
  'menu_book',
  'list_menu',
  'detail_menu'
]

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}

router.beforeEach(async(to, from, next) => {
  if (to.path === '/reservation-place') {
    const vuetifyStylesheet = document.createElement('link')
    vuetifyStylesheet.rel = 'stylesheet'
    vuetifyStylesheet.href = 'https://cdn.jsdelivr.net/npm/vuetify@2.1.7/dist/vuetify.min.css'
    document.head.appendChild(vuetifyStylesheet)
  }

  store.state.loading = true
  await store.dispatch('checkDomain')
  await CheckStore()

  const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))

  // store is active
  if (!isEmpty(store.state.selected_store)) {
    if (store.state.selected_store.setting.is_active === 0) {
      if (to.name !== 'non_active') {
        next({ name: 'non_active' })
        store.state.loading = false
      } else {
        next()
      }
    } else {
      if (auth_data !== null) {
        if (auth_data.auth_by === 'BASIC') {
          // if auth true
          if (authlink.indexOf(to.name) !== -1) {
            if (to.query.redirect) {
              next({ name: to.query.redirect })
            } else {
              const astra_outlet = store.state.store_astra
              const tmii_outlet = store.state.store_tmii
              const url_id = store.state.url_domain

              if (tmii_outlet.indexOf(url_id) !== -1) {
                window.location.href = 'https://order.kulinertmii.id'
              } else if (astra_outlet.indexOf(url_id) !== -1) {
                window.location.href = 'https://zestloungemenaraastra.myolsera.com'
              } else {
                next({ name: 'home' })
              }
            }
          } else {
            // if whiteList true
            if (whiteList.indexOf(to.name) !== -1) {
              CheckUrlId(to, from, next)
              CheckType(to, from, next)
              next()
            } else if (menubook.indexOf(to.name) !== -1) {
              if (store.state.selected_store.plan_type_id !== 'L') {
                if (store.state.selected_store.setting.active_book_menu) {
                  next()
                } else {
                  next({ name: 'non_active' })
                }
              } else {
                next({ name: 'non_active' })
              }
            } else {
              next()
            }
          }
        } else if (auth_data.auth_by === 'GUEST') {
          if (authlink.indexOf(to.name) !== -1) {
            next()
          } else {
            if (whiteList.indexOf(to.name) !== -1) {
              CheckUrlId(to, from, next)
              CheckType(to, from, next)
              next()
            } else if (menubook.indexOf(to.name) !== -1) {
              if (store.state.selected_store.plan_type_id !== 'L') {
                if (store.state.selected_store.setting.active_book_menu) {
                  next()
                } else {
                  next({ name: 'non_active' })
                }
              } else {
                next({ name: 'non_active' })
              }
            } else {
              next()
            }
          }
        } else {
          // if auth true
          if (authlink.indexOf(to.name) !== -1) {
            next()
          } else {
            // if whiteList true
            if (publicList.indexOf(to.name) !== -1) {
              next()
            } else if (whiteList.indexOf(to.name) !== -1) {
              CheckUrlId(to, from, next)
              CheckType(to, from, next)
              next()
            } else if (menubook.indexOf(to.name) !== -1) {
              if (store.state.selected_store.plan_type_id !== 'L') {
                if (store.state.selected_store.setting.active_book_menu) {
                  next()
                } else {
                  next({ name: 'non_active' })
                }
              } else {
                next({ name: 'non_active' })
              }
            } else {
              if (isEmpty(to.params)) {
                if (to.name === 'reservation_place' && to.query.date) {
                  next({ name: 'login', query: { redirect: to.name, date: to.query.date }})
                } else {
                  next({ name: 'login', query: { redirect: to.name }})
                }
              } else {
                if (to.name === 'order') {
                  if (store.state.selected_store.setting.no_auth_dinein === 1) {
                    next()
                  } else {
                    next({ name: 'login', query: { redirect: 'order', id: to.params.id }})
                  }
                } else {
                  next({ name: 'login', query: { redirect: 'home' }})
                }
              }
            }
          }
        }
      } else {
        next()
      }
    }
  }
})

router.afterEach((to, from) => {
  store.state.router_from = from
  setTimeout(function() { store.state.loading = false }, 1000)
})

export default router
